"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var RegisterPage = /*#__PURE__*/function (_window$AbstractView) {
    _inherits(RegisterPage, _window$AbstractView);

    var _super = _createSuper(RegisterPage);

    function RegisterPage(id, options) {
      var _this;

      _classCallCheck(this, RegisterPage);

      _this = _super.call(this, id, options);
      _this.$form = _this.$domElement.find("#create_customer");
      _this.$firstname = _this.$form.find('[name="customer[first_name]"]');
      _this.$lastname = _this.$form.find('[name="customer[last_name]"]');
      _this.$email = _this.$form.find('[name="customer[email]"]');
      _this.$password = _this.$form.find('[name="customer[password]"]');
      _this.$privacy = _this.$form.find('[name="customer[note][privacy]"]');
      _this.serverSideReport = _this.$form.find("span[data-server-side-report]").data("serverSideReport");
      return _this;
    }

    _createClass(RegisterPage, [{
      key: "init",
      value: function init() {
        this.$form.find(".register-form__extra-info-row .dropdown .dropdown-menu .dropdown-item").on("click", function (event) {
          var VALUE = $(event.delegateTarget).attr("data-value");
          var $dropdown = $(event.delegateTarget).closest(".dropdown");
          $dropdown.find(".dropdown-toggle").html(VALUE);
          $dropdown.siblings('input[type="hidden"]').val(VALUE);
          window.TweenMax.set($dropdown.find(".dropdown-menu"), {
            scrollTo: {
              y: 0,
              autoKill: false
            }
          });
        });
        var validatorRules = {
          'customer[first_name]': {
            required: true,
            lettersonly: true
          },
          'customer[last_name]': {
            required: true,
            lettersonly: true
          },
          'customer[email]': {
            required: true,
            email: true
          },
          'customer[password]': {
            required: true
          },
          'customer[note][privacy]': {
            required: true
          }
        };
        var validatorMessages = {
          'customer[first_name]': {
            lettersonly: this.$firstname.attr('data-lettersonly'),
            required: this.$firstname.attr('data-required')
          },
          'customer[last_name]': {
            lettersonly: this.$lastname.attr('data-lettersonly'),
            required: this.$lastname.attr('data-required')
          },
          'customer[email]': {
            required: this.$email.attr('data-required'),
            email: this.$email.attr('data-email')
          },
          'customer[password]': {
            required: this.$password.attr('data-required')
          },
          'customer[note][privacy]': {
            required: this.$privacy.attr('data-required')
          }
        };
        this.$form.validate({
          rules: validatorRules,
          messages: validatorMessages,
          errorElement: 'small',
          errorClass: 'form-text',
          highlight: function highlight(element) {
            console.log($(element));
            $(element).closest('.form-group').addClass('form-error');
          },
          unhighlight: function unhighlight(element) {
            $(element).closest('.form-group').removeClass('form-error');
          },
          submitHandler: function submitHandler(form) {
            try {
              form.submit();
            } catch (e) {
              $(window).triggerHandler(window.HelperModal.CLASSNAME + ".show", [{
                theme: window.AbstractBootstrapModal.THEME_DANGER,
                closeBtn: true,
                body: 'Si è verificato un problema. Ti preghiamo di riprovare più tardi.'
              }]);
            }
          }
        });
        Globals.preventScrollOnDropdown(this.$domElement.find(".dropdown"));

        if (this.serverSideReport.errors) {
          $(window).triggerHandler("helper-modal.show", [{
            theme: "danger",
            closeBtn: true,
            header: "Errore nella registrazione",
            body: this.$form.find("span[data-server-side-report]").html()
          }]);
        }

        _get(_getPrototypeOf(RegisterPage.prototype), "init", this).call(this);
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.$domElement.find(".dropdown").off();
        this.$form = null;
        this.$firstname = null;
        this.$lastname = null;
        this.$email = null;
        this.$password = null;
        this.$privacy = null;

        _get(_getPrototypeOf(RegisterPage.prototype), "dispose", this).call(this);
      }
    }]);

    return RegisterPage;
  }(window.AbstractView);

  window.RegisterPage = RegisterPage;
})(window);
